<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="deptFormRef" :rules="rules" :model="form" label-width="140px" >
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="form.companyName" clearable></el-input>
              </el-form-item>
              <el-form-item label="LOGO" prop="logoUrl" >
                <el-upload
                  class="flex col-bottom"
                  action=""
                  accept=".jpg,.jpeg,.png"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  :on-change="handleChangeFile"
                  list-type="picture"
                  :show-file-list="false">
                  <el-image v-if="logoUrl" style="height: 100px;width: 100px" :src="logoUrl" alt="加载失败"/>
                  <span v-else>未上传</span>
                  <el-button size="small" type="primary">上传图片</el-button>
                  <span slot="tip" class="el-upload__tip">&nbsp;&nbsp;文件大小不能超过4M</span>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <div style="float: right;">
                  <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
                  <el-button @click="close">取消</el-button>
                </div>

              </el-form-item>
            </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/api/http.js'
import config from '@/utils/config.js'
import MediaServer from './../service/MediaServer'

export default {
  name: "deptEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      title: '添加公司',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      platformList: [],
      mediaServer: new MediaServer(),
      form: {
        companyName: '',
        file: '',
        logoUrl: '',
      },
      logoUrl: '',
      rules: {
        companyName: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        logoUrl: [{ required: true, message: "请上传公司logo", trigger: "blur" }]
      },
    };
  },
  methods: {
    openDialog: function (form, callback) {
      this.showDialog = true;
      this.title = '添加公司'
      this.listChangeCallback = callback;
      if (form != null) {
        this.form = {...form};
        if (form.companyLogoPath) {
          this.logoUrl = form.companyLogoPath
          this.form.logoUrl = this.logoUrl
        }
        this.title = '编辑公司'
      }
    },
    handleRemove(file, fileList) {
      this.form.file = '';
      this.form.logoUrl = '';
      this.logoUrl = '';
    },
    handleChangeFile(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 4
      if(!isLt2M) {
        this.$message({
          message: '你选择的图片文件超过4M，不能上传，请裁剪图片至4M以下再进行上传！',
          type: 'warning'
        });
        file = null
        fileList = []
      }
      if (file.raw.type.indexOf('image') > -1) {
        this.form.file = file.raw;
        this.logoUrl = file.url;
        this.form.logoUrl = file.url;
      } else {
        return this.$message({showClose: true, message: '只能上传图片', type: 'warning'});
      }
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      let param = new FormData();
      param.append("companyName",this.form.companyName)
      param.append("file",this.form.file);
      let header = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      this.$refs.deptFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          if (that.form.companyId) {
            param.append("companyId",that.form.companyId)
            axios.post('/api/company/update', param, header).then(res => {
              that.dialogLoading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg)
              }
              that.$message.success('修改成功')
              that.showDialog = false
              if (that.listChangeCallback != null) {
                that.listChangeCallback();
              }
            })
          } else {
            axios.post('/api/company/add', param, header).then(res => {
              that.dialogLoading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg)
              }
              that.$message.success('添加成功')
              that.showDialog = false
              if (that.listChangeCallback != null) {
                that.listChangeCallback();
              }
            })
          }
        } else {
          that.dialogLoading = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        companyName: '',
        file: '',
        logoUrl: '',
      }
      this.logoUrl = ''
      this.showDialog = false;
      this.dialogLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/deptEdit.vue